import { contextFactory, useFormField } from '@frontend/design-system';
import {
  CompactTableActionsProps,
  CompactTableBulkActionsProps,
  CompactTableData,
  CompactTableManualFilters,
} from '../components/compact-table/types';

export type CompactTableContextType = {
  isLoading: boolean;
  toggleAllRowsExpanded: () => void;
  toggleSelectAllRows: () => void;
  areAllRowsSelected: boolean;
  allExpandedByDefault: boolean;
  setAllExpandedByDefault: React.Dispatch<React.SetStateAction<boolean>>;
  searchFieldProps: ReturnType<typeof useFormField<'text'>>;
  tableId: string;
  selectedRows: unknown[];
  data: unknown[];
  selectableRows: unknown[];
  tableActions: CompactTableActionsProps;
  bulkActions: CompactTableBulkActionsProps<any & CompactTableData>;
  isSelectable: boolean;
};

export const [CompactTableContext, useCompactTableContext] = contextFactory<CompactTableContextType>(
  'useCompactTableContext must be used within CompactTableContext'
);

export type CompactTableFilterContextType = {
  showEnabledFiltersBadge: boolean;
  setShowEnabledFiltersBadge: React.Dispatch<React.SetStateAction<boolean>>;
  manualFiltersRender?: CompactTableManualFilters;
};

export const [CompactTableFilterContext, useCompactTableFilterContext] = contextFactory<CompactTableFilterContextType>(
  'useCompactTableFilterContext must be used within CompactTableFilterContext'
);
